module.exports = __webpack_public_path__ + "083d447113b4883379201a09a2fa0c75.svg";